import { Card ,Row,Col, Divider,message, Typography, Statistic} from "antd";
import React, { Component } from "react";
import Chart from "react-apexcharts";
import storage from "../../utils/storage";
import {MobileOutlined,LikeOutlined,ClockCircleOutlined,CloudServerOutlined} from '@ant-design/icons';
import { configs } from "../../config/config";
import { defaultColors,defaultDropShadow,defaultStroke } from "../../model/dashboard/datasource";
import { GetBannerData, GetKindData, GetNfcChartsData, GetNfcChartsDataDate, getActivityPie, getDeviceNumsByCid } from "../../model/dashboard/requests";
import { formatDateString } from "../../utils/utils";
const {Title} = Typography


class DashBoardIndex extends Component {
    constructor(props){
        super(props)
        this.state = {
          total:0,
          storage:0,
          activity_stand_by_counts:0,
          inactivity_counts:0,
          nfc_activity_options:{},
          nfc_activity_series:[], 
          device_status_options:{},
          device_status_series:[], 
          device_owner_options:{},
          device_owner_series:[], 
          nfc_hour_options:{},
          nfc_hour_series:[],
          kind_options:{},
          kind_seriex:[]
        };
    }
    componentDidMount(){
       let nfc_activity_options = {
          chart: {
            dropShadow: defaultDropShadow,
          },
          stroke: defaultStroke,
          title: {
            text: 'Total',
            align: 'left'
          },
          colors: defaultColors,
          xaxis: {
              tickPlacement: 'between',
          },
       }
       let nfc_activity_series = []
       let nfc_activity_categories = []
       // 记载NFC 数据
       GetNfcChartsDataDate({start:"",end:"",custom_id:""}).then(res=>{
        if(res.data.code === 200){
            let ret = res.data.data
            let _category = []
            let _data_reads = []
            let _data_writes = []
            let _data_error_read = []
            let _data_error_write = []
            for(let i=0;i<ret.length;i++){
              let dates = formatDateString(ret[i].dates)
              _category.push(dates)
                _data_reads.push(ret[i].read_nums)
                _data_writes.push(ret[i].write_nums)
                _data_error_read.push(ret[i].error_reads)
                _data_error_write.push(ret[i].error_writes)
            }

            let _series_data_read = {}
            let _series_data_write = {}
            let _series_data_error_read = {}
            let _series_data_error_write = {}

            _series_data_read.data = _data_reads        
            _series_data_read.name = "Read" 
            nfc_activity_series.push(_series_data_read)

            _series_data_write.data = _data_writes        
            _series_data_write.name = "Write" 
            nfc_activity_series.push(_series_data_write)

            _series_data_error_read.data = _data_error_read        
            _series_data_error_read.name = "Error Read" 
            nfc_activity_series.push(_series_data_error_read)

            _series_data_error_write.data = _data_error_write        
            _series_data_error_write.name = "Error Write" 
            nfc_activity_series.push(_series_data_error_write)


            if(nfc_activity_categories.length <= 0 ){
              nfc_activity_categories.push(..._category)
            }

        }
      }).catch(err=>{
          message.error(err)
      })

      // 获取头部4个banner数据
      let total = 0
      let activity_stand_by_counts = 0
      let storage = 0
      let inactivity_counts = 0 
      GetBannerData().then(res=>{
        if(res.data.code === 200 ){
            let ret = res.data.data
            total = ret.total
            activity_stand_by_counts = ret.activity_stand_by_counts
            storage = ret.storage
            inactivity_counts = ret.inactivity_counts
        }
      }).catch(err=>{
        message.error(err)
      })

      // device status
      let device_status_options = {
        labels: [],
        stroke: { width: 0 },
        title: {
          text: 'Device Status',
          align: 'left'
        },
        fill:{
          colors: defaultColors,
        },
        legend: {
          show: true,
          position: "bottom",
          horizontalAlign: "center",
          width: "100%",
          height: 110,
          markers: {
            fillColors: defaultColors,
          },
          formatter: function (seriesName, opts) {
            return [
              seriesName,
              " : ",
              opts.w.globals.series[opts.seriesIndex],
            ];
          },
        },
        plotOptions: {
          pie:{
            expandOnClick: true,
            donut: {
              labels: {
                show:true,
                name:{
                  show:false
                },
                value:{
                  show:true
                },
                total: {
                  show: true,
                  showAlways:true,
                  formatter: function (w) {
                    return w.globals.seriesTotals.reduce((a, b) => {
                      return a + b
                    }, 0)
                  },
                },
              },
            },
          }
        },
      }

      let device_status_series = []
      let device_status_category = []
      getActivityPie({start:"",end:"",custom_id:0}).then(res=>{
        if(res.data.code === 200 ){
            let ret = res.data.data
            let category = ["","active","standby","inactive","lock"]
            for(let i = 0 ;i < ret.length;i++){
              device_status_category.push(category[ret[i].stat_type])
              device_status_series.push(ret[i].nums)
            }
      
        }
      }).catch(err=>{
        message.error(err)
      })


      // device owner
      let device_owner_options = {
        labels: [],
        stroke: { width: 0 },
        title: {
          text: 'Device Owners',
          align: 'left'
        },
        fill:{
          colors: defaultColors,
        },
        legend: {
          show: true,
          position: "bottom",
          horizontalAlign: "center",
          width: "100%",
          height: 110,
          markers: {
            fillColors: defaultColors,
          },
          formatter: function (seriesName, opts) {
            return [
              seriesName,
              " : ",
              opts.w.globals.series[opts.seriesIndex],
            ];
          },
        },
        plotOptions: {
          pie:{
            expandOnClick: true,
            donut: {
              labels: {
                show:true,
                name:{
                  show:false
                },
                value:{
                  show:true
                },
                total: {
                  show: true,
                  showAlways:true,
                  formatter: function (w) {
                    return w.globals.seriesTotals.reduce((a, b) => {
                      return a + b
                    }, 0)
                  },
                },
              },
            },
          }
        },
      }

      let device_owner_series = []
      let device_owner_category = []

      getDeviceNumsByCid().then(res=>{
        if(res.data.code === 200){
          let ret = res.data.data
          for(let i = 0 ;i < ret.length;i++){
            device_owner_category.push(ret[i].name)
            device_owner_series.push(ret[i].nums)
          }

        }
      }).catch(err=>{
        message.error(err)
      })

      // NFC line part
      let nfc_hour_options ={
        title: {
          text: 'NFC Operations (24 hours)',
          align: 'left'
        },
        colors: defaultColors,
        xaxis: {},
    }
    let nfc_hour_series = []
    let nfc_hour_category = []
    GetNfcChartsData({start:"",end:"",custom_id:""}).then(res=>{
      if(res.data.code === 200){
          let ret = res.data.data
          let _category = []
          let _data_reads = []
          let _data_writes = []
          let _data_errors = []
          for(let i=0;i<ret.length;i++){
              _category.push(ret[i].custom_id)
              _data_reads.push(ret[i].read_nums)
              _data_writes.push(ret[i].write_nums)
              _data_errors.push(ret[i].error_nums)
          }
          let _series_data_read = {}
          let _series_data_write = {}
          let _series_data_error = {}
          _series_data_read.data = _data_reads        
          _series_data_read.name = "Read" 
          nfc_hour_series.push(_series_data_read)

          _series_data_write.data = _data_writes        
          _series_data_write.name = "Write" 
          nfc_hour_series.push(_series_data_write)

          _series_data_error.data = _data_errors        
          _series_data_error.name = "Error" 
          nfc_hour_series.push(_series_data_error)

          if(nfc_hour_category.length <= 0 ){
            nfc_hour_category.push(..._category)
          }
      }

  }).catch(err=>{
      message.error(err)
  })

  // kind stat
  let kind_options = {
    labels: ["Lock","Normal","Factory Reset"],
    stroke: { width: 0 },
    fill:{
      colors: defaultColors,
    },
    title: {
      text: 'Device State',
      align: 'left'
    },
    legend: {
      show: true,
      position: "bottom",
      horizontalAlign: "center",
      width: "100%",
      height: 110,
      markers: {
        fillColors: defaultColors,
      },
      formatter: function (seriesName, opts) {
        return [
          seriesName,
          " :    ",
          opts.w.globals.series[opts.seriesIndex],
        ];
      },
    },
    plotOptions: {
      pie:{
        expandOnClick: true,
        donut: {
          labels: {
            show:true,
            name:{
              show:true
            },
            value:{
              show:true
            },
            total: {
              show: true,
              showAlways:true,
              formatter: function (w) {
                return w.globals.seriesTotals.reduce((a, b) => {
                  return a + b
                }, 0)
              },
            },
          },
        },
      }
    }
  }

  let kind_seriex = []
  GetKindData().then(res=>{
    if(res.data.code === 200){
      let ret = res.data.data
      kind_seriex.push(ret.lock_nums)
      kind_seriex.push(ret.unlock_nums)
      kind_seriex.push(ret.factory_nums)
    }
  }).catch(err=>{
    message.error(err)
  })


      setTimeout(() => {
        nfc_activity_options.xaxis.categories = [...nfc_activity_categories]
        device_status_options.labels = [...device_status_category]
        device_owner_options.labels = [...device_owner_category]
        nfc_hour_options.xaxis.categories = [...nfc_hour_category]
        this.setState({
          nfc_activity_options:nfc_activity_options,
          nfc_activity_series:nfc_activity_series,
          total:total,
          storage:storage,
          activity_stand_by_counts:activity_stand_by_counts,
          inactivity_counts:inactivity_counts,
          device_status_options:device_status_options,
          device_status_series:device_status_series,
          device_owner_options:device_owner_options,
          device_owner_series:device_owner_series,
          nfc_hour_options:nfc_hour_options,
          nfc_hour_series:nfc_hour_series,
          kind_options:kind_options,
          kind_seriex:kind_seriex

        })

      }, 500);
    

       
    }

    componentWillUnmount(){
        if (!storage.check(configs.cache.tokenKey)) {
            this.props.history.push("/")
        }
    }
    
    render(){
        return(
            <>
            <Title>Device Dashboard</Title>
            <Row gutter={16}>
              <Col className="gutter-row" span={6}>
              <Card bordered={false} className="criclebox h-full">
              <Statistic 
                title="Total Devices" 
                value={this.state.total}
                suffix={<MobileOutlined style={{color:'#851dd6',marginLeft:'200px'}} />} 
                valueStyle={{
                  color: '#0a0a0a',
                  fontSize:'30px',
              }} />
              </Card>

              </Col>
              <Col className="gutter-row" span={6}>
                <Card bordered={false} className="criclebox h-full">
                <Statistic 
                  title="Storage" 
                  value={this.state.storage}
                  suffix= {<ClockCircleOutlined  style={{color:'#851dd6',marginLeft:'200px'}} /> }
                  valueStyle={{
                    color: '#0a0a0a',
                    fontSize:'30px'
                  }} />
                </Card>
              </Col>
              <Col className="gutter-row" span={6}>
                <Card bordered={false} className="criclebox h-full">
                <Statistic 
                  title="Active / Standby" 
                  value={this.state.activity_stand_by_counts}
                  suffix={<LikeOutlined style={{color:'#851dd6',marginLeft:'200px'}} />} 
                  valueStyle={{
                    color: '#0a0a0a',
                    fontSize:'30px'
                  }} />
                </Card>
              </Col>
              <Col className="gutter-row" span={6}>
                <Card bordered={false} className="criclebox h-full">
        
                    <Statistic 
                    title="Inactive Devices" 
                    value={this.state.inactivity_counts}
                    suffix={<CloudServerOutlined style={{color:'#851dd6',marginLeft:'200px'}} />} 
                    valueStyle={{
                      color: '#0a0a0a',
                      fontSize:'30px',
                    }} />

      
              </Card>
            </Col>
          </Row>
        <Divider />
         <Row gutter={16}>
          <Col className="gutter-row" span={12}>
            <Card bordered={false} className="criclebox h-full">
            <Chart
                options={this.state.nfc_activity_options}
                series={this.state.nfc_activity_series}
                type="line"
                width={"100%"}
                height="400px"
            />
            </Card>
          </Col>
            <Col className="gutter-row" span={6}>
            <Card bordered={false} className="criclebox h-full">
              <Chart
                  options={this.state.device_status_options}
                  series={this.state.device_status_series}
                  type="donut"
                  width="100%"
                  height="400px"
              />
            </Card>
            </Col>
            <Col className="gutter-row" span={6}>
            <Card bordered={false} className="criclebox h-full">
              <Chart
                  options={this.state.device_owner_options}
                  series={this.state.device_owner_series}
                  type="donut"
                  width="100%"
                  height="400px"
              />
            </Card>
            </Col>

        </Row>
        <Divider />
        <Row gutter={16}>
          <Col className="gutter-row" span={6}>
            <Card bordered={false} className="criclebox h-full">
            <Chart
                options={this.state.kind_options}
                series={this.state.kind_seriex}
                type="donut"
                height="400"
            />
            </Card>
          </Col>
            <Col className="gutter-row" span={18}>
            <Card bordered={false} className="criclebox h-full">
              <Chart
                  options={this.state.nfc_hour_options}
                  series={this.state.nfc_hour_series}
                  type="bar"
                  width="100%"
                  height="400"
              />
            </Card>
            </Col>
        </Row>
      </>
        )
    }
}

export default DashBoardIndex;